export default [
  '09:00–19:00',
  '09:00–19:00', 
  '09:00–19:00', 
  '09:00–19:00',
  '09:00–19:00',
  '09:00–17:00',
  'Выходной'
];